import { render } from "./VSideModal.vue?vue&type=template&id=0f9853d0"
import script from "./VSideModal.vue?vue&type=script&lang=js"
export * from "./VSideModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__